export default {"src":"/_next/static/media/ChoosetherightIdeapoke-01.f3c25ba5.svg","height":585,"width":850,"blurWidth":0,"blurHeight":0};